import graphql__f4faf825efaf5ab1e430 from "./__generated__/ContributionThemesLabel_themes.graphql.js";import classNames from "classnames";
import { graphql, useFragment } from "react-relay";

import Icon from "../../Utils/Icon";

const ContributionThemesLabel = props => {
  const themes = useFragment(ContributionThemesLabel_themes, props.themes);

  const className = classNames("contribution-themes-label", props.className);
  const themeClassName = classNames("padding-xxs", "with-icon", "d-inline-flex", "badge");

  if (themes.length === 0) return null;

  return (
    <div className={className}>
      {themes.map(({ id, name, iconClass, primaryColor, primaryContrastColor }) => (
        <div
          key={id}
          className={themeClassName}
          style={{ backgroundColor: primaryColor, color: primaryContrastColor }}
        >
          {iconClass && <Icon className={iconClass} />}
          <span className="with-icon-text">{name}</span>
        </div>
      ))}
    </div>
  );
};

const ContributionThemesLabel_themes = graphql__f4faf825efaf5ab1e430;

export default ContributionThemesLabel;
